const MIME_TYPE_NAME = {
  'application/pdf': '.pdf',
  'text/csv': '.csv',
  'image/jpeg': '.jpg/jpeg',
  'image/png': '.png',
  'text/plain': '.txt',
  'application/json': '.json',
};

export function formatBytesHelper(bytesSize) {
  const isFalsy = !bytesSize;
  const isNotNumber = typeof bytesSize !== 'number';
  const isNotSafeInteger = !Number.isSafeInteger(bytesSize);
  const isNegativeNumber = bytesSize < 0;
  const isZero = bytesSize === 0;

  if ((isFalsy && !isZero) || isNotNumber || isNotSafeInteger || isNegativeNumber) {
    return '';
  }

  if (isZero) return '0 Bytes';

  const kiloBytes = 1024;
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const floorUnitsIdx = Math.floor(Math.log(bytesSize) / Math.log(kiloBytes));

  let unitIdx = 0;

  if (floorUnitsIdx < 0) {
    unitIdx = 0;
  } else if (floorUnitsIdx > units.length - 1) {
    unitIdx = units.length - 1;
  } else {
    unitIdx = floorUnitsIdx;
  }

  /** this decimal depend on unit Bytes=0, KB=1, MB=2, GB=3, TB=4 */
  const parsedBytes = parseFloat((bytesSize / kiloBytes ** unitIdx).toFixed(2));

  return `${parsedBytes} ${units[unitIdx]}`;
}

export function resolveMimeTypeName(mimeTypes) {
  if (!Array.isArray(mimeTypes)) return ''; // Guard clause for invalid input

  const matchedNames = [];

  for (const mimeType of mimeTypes) {
    const mimeName = MIME_TYPE_NAME[mimeType];
    if (mimeName) {
      matchedNames.push(mimeName);
    }
  }

  if (matchedNames.length <= 0) return '';

  if (matchedNames.length === 1) return matchedNames[0];

  return `${matchedNames.slice(0, -1).join(', ')} or ${matchedNames.at(-1)}`;
}
